var map = {
	"./aud-flag.svg": 684,
	"./cad-flag.svg": 685,
	"./cny-flag.svg": 686,
	"./hkd-flag.svg": 687,
	"./inr-flag.svg": 688,
	"./jpy-flag.svg": 689,
	"./pln-flag.svg": 690
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 314;